import { request } from './http';
import type {
  SimulateTransactionRequest,
  SimulateTransactionResult,
} from '@/types/sandbox';

export const adminSandboxApi = {
  simulateTransaction(payload: SimulateTransactionRequest) {
    return request<SimulateTransactionResult>({
      url: '/admin/sandbox/simulate-transaction',
      method: 'POST',
      data: payload,
    });
  },
};
